import { render } from "./SearchResultBox.vue?vue&type=template&id=2be952bc&scoped=true"
import script from "./SearchResultBox.vue?vue&type=script&lang=js"
export * from "./SearchResultBox.vue?vue&type=script&lang=js"

import "./SearchResultBox.vue?vue&type=style&index=0&id=2be952bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be952bc"]])

export default __exports__